import { render, staticRenderFns } from "./LegacyContent.vue?vue&type=template&id=f5620cec&"
import script from "./LegacyContent.vue?vue&type=script&lang=js&"
export * from "./LegacyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports